export default "__VITE_ASSET__C9bN3dmu__"